<template>
	<div class="flex1" style="height:100%">
		<Title :title="'电池寿命预测'"></Title>
		<MyEcharts v-if="showcdata" :id="'socInterval'" :options="cdata" />
	</div>
</template>

<script>
	import MyEcharts from '../charts/echarts.vue'
	import Title from '../title.vue'
	import * as echarts from 'echarts5'
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default {
		data() {
			return {
				showcdata: false,
				// title:"车辆新增及活跃趋势",
				cdata: {
          legend: {
            right: "3%",
            data: ['预测', '实际'],
            icon: 'roundRect',      
            itemHeight: 8, // 修改icon图形大小 
            itemWidth: 10      
          },
					xAxis: {
						type: 'category',
						boundaryGap: false,
					},
          
					yAxis: {
						type: 'value',
						splitLine:false
					},
					series: [{
						type: 'line',
						smooth: true,
            name:'预测',
						lineStyle: {
							width: 2,
							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
								{
									offset: 0.1,
									color: '#B8FF7E' // 0% 处的颜色
								},
								{
									offset: 0.9,
									color: '#B8FF7E' // 100% 处的颜色
								}])
						},
						itemStyle: {
							normal: {
								color: '#B8FF7E', //改变折线点的颜色
								// lineStyle: {
								// 	color: '#B8FF7E' //改变折线颜色
								// }
							}
						}
					},{
						type: 'line',
						smooth: true,
            name: '实际',
						lineStyle: {
							width: 2,
							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
								{
									offset: 0.1,
									color: '#36A1FF' // 0% 处的颜色
								},
								{
									offset: 0.9,
									color: '#36A1FF' // 100% 处的颜色
								}])
						},
						itemStyle: {
							normal: {
								color: '#36A1FF', //改变折线点的颜色
								// lineStyle: {
								// 	color: '#B8FF7E' //改变折线颜色
								// }
							}
						}
					}]
				},
        cdata1: {}
			};
		},
		components: {
			MyEcharts,
			Title
		},
		mounted() {
			this.getBattery24hours()
		},
		methods: {
			//获取24小时电次数分布
			getBattery24hours() {
				let params = {
				  "enCode": "per_vehicle-电池寿命预测",
				  "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") : 'LDP31B967MG929008'
				}
				dataInterface.dataFaceApi(params).then((res) => {
					if(res) {
						console.log(res,)
						let data = []
						let xAxis = []
            let data1 = []
            res.forEach(item => {
							xAxis.push(item.future_year || 2023)
							data.push(item.soh)
              data1.push(item.soh_actual)
						})
						this.cdata.xAxis.data = xAxis
						this.cdata.series[0].data = data
            this.cdata.series[1].data = data1
						this.showcdata = true
					}
				}).catch((err) => {
					console.log(err);
				  });
			}
		}
	};
</script>

<style lang="scss" scoped>
@import './comm.scss';
</style>
